import {warehouseOptionsSelector} from '../../data/warehouses.js'
import {useSelector} from '../../store.js'
import Zelect from './Zelect.js'

/**
 * A Warehouse select component
 *
 * @param {object} props Render props
 * @param {string|Function} [props.label] String label or function to render label
 * @param {string} props.id
 * @param {string|number} props.value
 * @param {Function} props.onChange
 * @param {string} [props.errorMessage]
 * @param {boolean} [props.disabled]
 * @param {Function} [props.optionsSelector]
 * @param {boolean} [props.addEmptyOption]
 * @param {ReactNode} [props.emptyOptionDisplay]
 * @returns {React.ReactNode}
 */
export function WarehouseSelect({
  label = 'Warehouse',
  id,
  value,
  onChange,
  errorMessage,
  disabled,
  optionsSelector = warehouseOptionsSelector,
  addEmptyOption,
  emptyOptionDisplay,
}) {
  const options = useSelector(optionsSelector)

  return (
    <Zelect
      label={label}
      id={id}
      value={value}
      options={options}
      onChange={(option, ...args) => onChange(option.entity, option, ...args)}
      errorMessage={errorMessage}
      disabled={disabled}
      addEmptyOption={addEmptyOption}
      emptyOptionDisplay={emptyOptionDisplay}
    />
  )
}
